import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DspxLogoutComponent } from 'dspx-core';
import { AgencyListComponent } from './components/agency-list/agency-list.component';
import { AgencyComponent } from './components/agency/agency.component';
import { ApplicationDetailConcessionsComponent } from './components/application-detail-concessions/application-detail-concessions.component';
import { ApplicationDetailCreateUpdateCarerComponent } from './components/application-detail-create-update-carer/application-detail-create-update-carer.component';
import { ApplicationDetailCreateUpdatePlacementComponent } from './components/application-detail-create-update-placement/application-detail-create-update-placement.component';
import { BankDetailsComponent } from './components/bank-detail/bank-detail.component';
import { CareAllowanceApplicationListComponent } from './components/care-allowance-application-list/care-allowance-application-list.component';
import { CareAllowanceInvoicePeriodComponent } from './components/care-allowance-invoice-period/care-allowance-invoice-period.component';
import { CareAllowancePlacementAdjustmentListComponent } from './components/care-allowance-placement-adjustment-list/care-allowance-placement-adjustment-list.component';
import { CareAllowancePlacementAdjustmentComponent } from "./components/care-allowance-placement-adjustment/care-allowance-placement-adjustment.component";
import { CareAllowancePlacementBulkAdHocInvoiceQueryListComponent } from "./components/care-allowance-placement-bulk-ad-hoc-invoice-query-list/care-allowance-placement-bulk-ad-hoc-invoice-query-list.component";
import { CareAllowancePlacementBulkAdHocInvoiceQueryComponent } from "./components/care-allowance-placement-bulk-ad-hoc-invoice-query/care-allowance-placement-bulk-ad-hoc-invoice-query.component";
import { CareAllowancePlacementInvoiceListComponent } from './components/care-allowance-placement-invoice-list/care-allowance-placement-invoice-list.component';
import { CareAllowancePlacementListComponent } from './components/care-allowance-placement-list/care-allowance-placement-list.component';
import { CareAllowancePlacementRuleListComponent } from './components/care-allowance-placement-rule-list/care-allowance-placement-rule-list.component';
import { CareAllowancePlacementRuleComponent } from './components/care-allowance-placement-rule/care-allowance-placement-rule.component';
import { CareAllowancePlacementComponent } from './components/care-allowance-placement/care-allowance-placement.component';
import { CareAllowanceRateListComponent } from './components/care-allowance-rate-list/care-allowance-rate-list.component';
import { CareAllowanceRateComponent } from './components/care-allowance-rate/care-allowance-rate.component';
import { CareAllowanceYearListComponent } from './components/care-allowance-year-list/care-allowance-year-list.component';
import { CareAllowanceYearComponent } from './components/care-allowance-year/care-allowance-year.component';
import { ConcessionsApplicationBulkUploadDetailComponent } from './components/concessions-application-bulk-upload-detail/concessions-application-bulk-upload-detail.component';
import { ConcessionsApplicationBulkUploadErrorLogListComponent } from './components/concessions-application-bulk-upload-error-log-list/concessions-application-bulk-upload-error-log-list.component';
import { ConcessionsApplicationBulkUploadListComponent } from './components/concessions-application-bulk-upload-list/concessions-application-bulk-upload-list.component';
import { ConcessionsApplicationBulkUploadComponent } from './components/concessions-application-bulk-upload/concessions-application-bulk-upload.component';
import { ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent } from './components/concessions-application-eda-and-pow-gold-card-municipal-rates/concessions-application-eda-and-pow-gold-card-municipal-rates.component';
import { ConcessionsApplicationInfoComponent } from './components/concessions-application-info/concessions-application-info.component';
import { ConcessionsApplicationListComponent } from './components/concessions-application-list/concessions-application-list.component';
import { ConcessionsApplicationNonMainsEnergyComponent } from './components/concessions-application-non-mains-energy/concessions-application-non-mains-energy.component';
import { ConcessionsApplicationNonMainsLifeSupportComponent } from './components/concessions-application-non-mains-life-support/concessions-application-non-mains-life-support.component';
import { ConcessionsApplicationNonMainsMedicalCoolingComponent } from './components/concessions-application-non-mains-medical-cooling/concessions-application-non-mains-medical-cooling.component';
import { ConcessionsApplicationNonMainsWaterComponent } from './components/concessions-application-non-mains-water/concessions-application-non-mains-water.component';
import { ConcessionsApplicationReadyForApprovalListComponent } from './components/concessions-application-ready-for-approval-list/concessions-application-ready-for-approval-list.component';
import { ConcessionsApplicationRebateCalculationRuleListComponent } from './components/concessions-application-rebate-calculation-rule-list/concessions-application-rebate-calculation-rule-list.component';
import { ConcessionsInvoiceListComponent } from './components/concessions-invoice-list/concessions-invoice-list.component';
import { ConcessionsRebateCalculationRuleComponent } from './components/concessions-rebate-calculation-rule/concessions-rebate-calculation-rule.component';
import { ErrorLogListComponent } from './components/error-log-list/error-log-list.component';
import { ExportedInvoiceListComponent } from './components/exported-invoice-list/exported-invoice-list.component';
import { ExportedInvoiceComponent } from './components/exported-invoice/exported-invoice.component';
import { GLStringLookupMappingSetListComponent } from './components/gl-string-lookup-mapping-set-list/gl-string-lookup-mapping-set-list.component';
import { GLStringLookupMappingSetComponent } from './components/gl-string-lookup-mapping-set/gl-string-lookup-mapping-set.component';
import { GLStringLookupMappingComponent } from './components/gl-string-lookup-mapping/gl-string-lookup-mapping.component';
import { GLStringMappingListComponent } from './components/gl-string-mapping-list/gl-string-mapping-list.component';
import { GLStringMappingComponent } from './components/gl-string-mapping/gl-string-mapping.component';
import { IccmsRequestProcessingScheduleListComponent } from './components/iccms-request-processing-schedule-list/iccms-request-processing-schedule-list.component';
import { IccmsRequestProcessingScheduleComponent } from './components/iccms-request-processing-schedule/iccms-request-processing-schedule.component';
import { JobRunLogListComponent } from './components/job-run-log-list/job-run-log-list.component';
import { JobScheduleListComponent } from './components/job-schedule-list/job-schedule-list.component';
import { JobScheduleComponent } from './components/job-schedule/job-schedule.component';
import { LandingComponent } from './components/landing/landing.component';
import { OrganisationListComponent } from './components/organisation-list/organisation-list.component';
import { OrganisationComponent } from './components/organisation/organisation.component';
import { PaymentRuleComponent } from './components/payment-rule/payment-rule.component';
import { PersonDetailComponent } from './components/person-detail/person-detail.component';
import { PersonListComponent } from './components/person-list/person-list.component';
import { ReferenceDataListComponent } from "./components/reference-data-list/reference-data-list.component";
import { ReferenceDataComponent } from "./components/reference-data/reference-data.component";
import { ReportListComponent } from "./components/report-list/report-list.component";
import { SettingListComponent } from './components/setting-list/setting-list.component';
import { SettingComponent } from './components/setting/setting.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserComponent } from './components/user/user.component';
import { VendorListComponent } from './components/vendor-list/vendor-list.component';
import { VendorComponent } from './components/vendor/vendor.component';
import { VmgEmailTemplateComponent } from './components/vmg-email-template/vmg-email-template.component';
import { ROUTE_CONSTANTS } from './constants/route.constants';
import { ComponentDeactivationService } from "./services/component-deactivation.service";
import { CareAllowanceLocalAdoptionComponent } from './components/care-allowance-local-adoption/care-allowance-local-adoption.component';
import { CareAllowancePersonComponent } from "./components/care-allowance-person/care-allowance-person.component";
import { VictorianPatientTransportAssistanceSchemeApplicationListComponent } from './components/vptas-application-list/victorian-patient-transport-assistance-scheme-application-list.component';
import { VictorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateListComponent } from './components/vpts-application-rebate-calculation-rate-list/victorian-patient-transport-assistance-scheme-application-rebate-calculation-rate-list.component';
import { VictorianPatientTransportAssistanceSchemeRebateCalculationRuleComponent } from './components/vpts-rebate-calculation-rule/victorian-patient-transport-assistance-scheme-rebate-calculation-rule.component';
import { VictorianPatientTransportAssistanceSchemeNominatedPatientDetailsComponent } from './components/victorian-patient-transport-assistance-scheme-nominated-patient-details/victorian-patient-transport-assistance-scheme-nominated-patient-details.component';
import { VictorianPatientTransportAssistanceSchemeApplication } from './components/victorian-patient-transport-assistance-scheme-application/victorian-patient-transport-assistance-scheme-application.component';
import { VptasApplicationSubsidyListComponent } from './components/vptas-application-subsidy-list/vptas-application-subsidy-list.component';
import { VptasApplicationTripListComponent } from './components/vptas-application-trip-list/vptas-application-trip-list.component';
import { VptasInvoiceListComponent } from './components/vptas-invoice-list/vptas-invoice-list.component';
import { ApplicationDetailVptasComponent } from './components/application-detail-vptas/application-detail-vptas.component';
import { VptasSpecialistListComponent } from './components/vptas-specialist-list/vptas-specialist-list.component';
import { VptasSpecialistComponent } from './components/vptas-specialist/vptas-specialist.component';
import { VptasSpecialistProviderInformationComponent } from './components/vptas-specialist-provider-information/vptas-specialist-provider-information.component';
import { VptasLGAListComponent } from './components/vptas-lga-list/vptas-lga-list.component';
import { VptasLgaComponent } from './components/vptas-lga/vptas-lga.component';
import { VptasAdjustmentApplication } from './components/vptas-adjustment-application/vptas-adjustment-application.component';
import { VptasApplicationSubsidyComponent } from './components/vptas-application-subsidy/vptas-application-subsidy.component';

const routes: Routes = [
  {
    // Loading root of site will redirect to /reference-data-list
    path: '',
    component: LandingComponent
  },
  {
    path: ROUTE_CONSTANTS.logout,
    component: DspxLogoutComponent
  },
  {
    path: '',
    children: [
      // User
      {
        path: ROUTE_CONSTANTS.user.list,
        component: UserListComponent,
      },
      {
        path: ROUTE_CONSTANTS.user.edit,
        component: UserComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Applications
      {
        path: ROUTE_CONSTANTS.careAllowanceApplication.list,
        component: CareAllowanceApplicationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.applicationDetailCreateUpdateCarer.view,
        component: ApplicationDetailCreateUpdateCarerComponent,
      },
      {
        path: ROUTE_CONSTANTS.applicationDetailCreateUpdatePlacement.view,
        component: ApplicationDetailCreateUpdatePlacementComponent,
      },
      // Concessions Applications
      {
        path: ROUTE_CONSTANTS.concessionsApplication.list.myApplications,
        component: ConcessionsApplicationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplication.list.pendingReview,
        component: ConcessionsApplicationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplication.list.readyForApproval,
        component: ConcessionsApplicationReadyForApprovalListComponent,
      },
      // create concessions application
      {
        path: ROUTE_CONSTANTS.concessionsApplication.prefix,
        component: ConcessionsApplicationInfoComponent
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplication.newForPerson,
        component: ConcessionsApplicationInfoComponent
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsWater.new,
        component: ConcessionsApplicationNonMainsWaterComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsWater.newForPerson,
        component: ConcessionsApplicationNonMainsWaterComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsWater.edit,
        component: ConcessionsApplicationNonMainsWaterComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsEnergy.new,
        component: ConcessionsApplicationNonMainsEnergyComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsEnergy.newForPerson,
        component: ConcessionsApplicationNonMainsEnergyComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsEnergy.edit,
        component: ConcessionsApplicationNonMainsEnergyComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsMedicalCooling.new,
        component: ConcessionsApplicationNonMainsMedicalCoolingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsMedicalCooling.newForPerson,
        component: ConcessionsApplicationNonMainsMedicalCoolingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsMedicalCooling.edit,
        component: ConcessionsApplicationNonMainsMedicalCoolingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsLifeSupport.new,
        component: ConcessionsApplicationNonMainsLifeSupportComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsLifeSupport.newForPerson,
        component: ConcessionsApplicationNonMainsLifeSupportComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationNonMainsLifeSupport.edit,
        component: ConcessionsApplicationNonMainsLifeSupportComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.new,
        component: ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.newForPerson,
        component: ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.edit,
        component: ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.list.rebateRulesApproved,
        component: ConcessionsApplicationRebateCalculationRuleListComponent,
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.list.rebateRulesPendingApproval,
        component: ConcessionsApplicationRebateCalculationRuleListComponent,
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.prefix,
        component: ConcessionsRebateCalculationRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.edit,
        component: ConcessionsRebateCalculationRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.viewPending,
        component: ConcessionsRebateCalculationRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.rule.edit,
        component: PaymentRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Placement Rule
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementRule.list,
        component: CareAllowancePlacementRuleListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementRule.prefix,
        component: CareAllowancePlacementRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementRule.edit,
        component: CareAllowancePlacementRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Financial Year
      {
        path: ROUTE_CONSTANTS.careAllowanceFinancialYear.list,
        component: CareAllowanceYearListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceFinancialYear.prefix,
        component: CareAllowanceYearComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceFinancialYear.edit,
        component: CareAllowanceYearComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceFinancialYear.editWithInvoicePeriods,
        component: CareAllowanceYearComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Calendar Year
      {
        path: ROUTE_CONSTANTS.careAllowanceCalendarYear.list,
        component: CareAllowanceYearListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceCalendarYear.prefix,
        component: CareAllowanceYearComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceCalendarYear.edit,
        component: CareAllowanceYearComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceCalendarYear.editWithInvoicePeriods,
        component: CareAllowanceYearComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Invoice Period
      {
        path: ROUTE_CONSTANTS.careAllowanceInvoicePeriod.edit,
        component: CareAllowanceInvoicePeriodComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Rate
      {
        path: ROUTE_CONSTANTS.careAllowanceRate.list.ratesApproved,
        component: CareAllowanceRateListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceRate.list.ratesPendingApproval,
        component: CareAllowanceRateListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceRate.prefix,
        component: CareAllowanceRateComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceRate.edit,
        component: CareAllowanceRateComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceRate.viewPending,
        component: CareAllowanceRateComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Placement
      {
        path: ROUTE_CONSTANTS.careAllowancePlacement.list,
        component: CareAllowancePlacementListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacement.view,
        component: CareAllowancePlacementComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacement.viewFromPerson,
        component: CareAllowancePlacementComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacement.viewFromApplication,
        component: CareAllowancePlacementComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Placement Adjustments
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.listViaPlacementList,
        component: CareAllowancePlacementAdjustmentListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.listViaPlacementDetail,
        component: CareAllowancePlacementAdjustmentListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.listViaPersonDetail,
        component: CareAllowancePlacementAdjustmentListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.newViaPlacementList,
        component: CareAllowancePlacementAdjustmentComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.newViaPersonDetail,
        component: CareAllowancePlacementAdjustmentComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.newViaPlacementDetail,
        component: CareAllowancePlacementAdjustmentComponent
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.viewViaPlacementList,
        component: CareAllowancePlacementAdjustmentComponent
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.viewViaPersonDetail,
        component: CareAllowancePlacementAdjustmentComponent
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.editWithGeneratedAdjustmentLinesViaPlacementList,
        component: CareAllowancePlacementAdjustmentComponent
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementAdjustment.editWithGeneratedAdjustmentLinesViaPersonDetail,
        component: CareAllowancePlacementAdjustmentComponent
      },
      // Care Allowance Placement Invoices
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementInvoice.listViaPlacementList,
        component: CareAllowancePlacementInvoiceListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementInvoice.listViaPersonDetail,
        component: CareAllowancePlacementInvoiceListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementInvoice.listViaPlacementDetail,
        component: CareAllowancePlacementInvoiceListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementInvoice.list,
        component: CareAllowancePlacementInvoiceListComponent,
      },
      // Care Allowance Local Adoption
      {
        path: ROUTE_CONSTANTS.careAllowanceLocalAdoption.newViaPersonDetail,
        component: CareAllowanceLocalAdoptionComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceLocalAdoption.view,
        component: CareAllowanceLocalAdoptionComponent
      },
      {
        path: ROUTE_CONSTANTS.careAllowanceLocalAdoption.newWithMatchViaPersonList,
        component: CareAllowanceLocalAdoptionComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      //
      // ICCMS Request Processing Schedules
      {
        path: ROUTE_CONSTANTS.iccmsRequestProcessingSchedule.list,
        component: IccmsRequestProcessingScheduleListComponent,
      },
      {
        path: ROUTE_CONSTANTS.iccmsRequestProcessingSchedule.prefix,
        component: IccmsRequestProcessingScheduleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.iccmsRequestProcessingSchedule.edit,
        component: IccmsRequestProcessingScheduleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Care Allowance Placement Bulk Ad Hoc Invoice Query
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.list,
        component: CareAllowancePlacementBulkAdHocInvoiceQueryListComponent,
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.prefix,
        component: CareAllowancePlacementBulkAdHocInvoiceQueryComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.edit,
        component: CareAllowancePlacementBulkAdHocInvoiceQueryComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.viewQuery,
        component: CareAllowancePlacementBulkAdHocInvoiceQueryComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Reference Data
      {
        path: ROUTE_CONSTANTS.referenceData.list,
        component: ReferenceDataListComponent,
      },
      {
        path: ROUTE_CONSTANTS.referenceData.prefix,
        component: ReferenceDataComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.referenceData.edit,
        component: ReferenceDataComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // GL String Mappings
      {
        path: ROUTE_CONSTANTS.glStringMapping.list,
        component: GLStringMappingListComponent,
      },
      {
        path: ROUTE_CONSTANTS.glStringMapping.prefix,
        component: GLStringMappingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.glStringMapping.edit,
        component: GLStringMappingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // GL String Lookup Mapping Sets
      {
        path: ROUTE_CONSTANTS.glStringLookupMappingSet.list,
        component: GLStringLookupMappingSetListComponent,
      },
      {
        path: ROUTE_CONSTANTS.glStringLookupMappingSet.prefix,
        component: GLStringLookupMappingSetComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.glStringLookupMappingSet.edit,
        component: GLStringLookupMappingSetComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // GL String Lookup Mappings
      {
        path: ROUTE_CONSTANTS.glStringLookupMapping.new,
        component: GLStringLookupMappingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.glStringLookupMapping.edit,
        component: GLStringLookupMappingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Settings
      {
        path: ROUTE_CONSTANTS.setting.list,
        component: SettingListComponent,
      },
      {
        path: ROUTE_CONSTANTS.setting.edit,
        component: SettingComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Organisations
      {
        path: ROUTE_CONSTANTS.organisation.list,
        component: OrganisationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.organisation.prefix,
        component: OrganisationComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.organisation.edit,
        component: OrganisationComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Persons
      {
        path: ROUTE_CONSTANTS.person.list,
        component: PersonListComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.updateCreateCarerApplication,
        component: PersonListComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.updateCreatePlacementApplication,
        component: PersonListComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.updateCreateLocalAdoptionPlacement,
        component: PersonListComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.viewDetail,
        component: PersonDetailComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.viewDetailFromPlacementList,
        component: PersonDetailComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.updateCreateCarerApplicationViewPerson,
        component: PersonDetailComponent,
      },
      {
        path: ROUTE_CONSTANTS.person.updateCreatePlacementApplicationViewPerson,
        component: PersonDetailComponent,
      },
      // Vendors
      {
        path: ROUTE_CONSTANTS.vendor.list,
        component: VendorListComponent
      },
      {
        path: ROUTE_CONSTANTS.vendor.edit,
        component: VendorComponent,
      },
      //Bank Details
      {
        path: ROUTE_CONSTANTS.bankDetails.edit,
        component: BankDetailsComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // Error Log
      {
        path: ROUTE_CONSTANTS.errorLog.list,
        component: ErrorLogListComponent
      },
      {
        path: ROUTE_CONSTANTS.vmgEmailTemplate.new,
        component: VmgEmailTemplateComponent,
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationDetail.view,
        component: ApplicationDetailConcessionsComponent,
      },
      // Job Schedule
      {
        path: ROUTE_CONSTANTS.jobSchedule.list,
        component: JobScheduleListComponent
      },
      {
        path: ROUTE_CONSTANTS.jobSchedule.prefix,
        component: JobScheduleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.jobSchedule.edit,
        component: JobScheduleComponent,
        canDeactivate: [ComponentDeactivationService]
      },
      // Job Log
      {
        path: ROUTE_CONSTANTS.job.list,
        component: JobRunLogListComponent
      },
      {
        path: ROUTE_CONSTANTS.exportedInvoice.list,
        component: ExportedInvoiceListComponent
      },
      {
        path: ROUTE_CONSTANTS.exportedInvoice.edit,
        component: ExportedInvoiceComponent
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationDetail.invoiceList,
        component: ConcessionsInvoiceListComponent
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationBulkUpload.prefix,
        component: ConcessionsApplicationBulkUploadComponent
      },
      {
        path: ROUTE_CONSTANTS.errorLogBulkUploadList.list,
        component: ConcessionsApplicationBulkUploadErrorLogListComponent
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationBulkUploadList.list,
        component: ConcessionsApplicationBulkUploadListComponent
      },
      {
        path: ROUTE_CONSTANTS.agency.list,
        component: AgencyListComponent
      },
      {
        path: ROUTE_CONSTANTS.agency.prefix,
        component: AgencyComponent,
        canDeactivate: [ComponentDeactivationService]
      },
      {
        path: ROUTE_CONSTANTS.agency.edit,
        component: AgencyComponent,
        canDeactivate: [ComponentDeactivationService]
      },
      {
        path: ROUTE_CONSTANTS.concessionsApplicationBulkUploadDetail.viewDetail,
        component: ConcessionsApplicationBulkUploadDetailComponent
      },
      // Report List
      {
        path: ROUTE_CONSTANTS.reportList.list,
        component: ReportListComponent,
      },
      // Care allowance contact person detail
      {
        path: ROUTE_CONSTANTS.person.careAllowancePerson.prefix,
        component: CareAllowancePersonComponent,
        canDeactivate: [ComponentDeactivationService]
      },
      {
        path: ROUTE_CONSTANTS.person.careAllowancePerson.edit,
        component: CareAllowancePersonComponent,
        canDeactivate: [ComponentDeactivationService]
      },
      // VPTAS Applications      
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.subsidies,
        component: VptasApplicationSubsidyListComponent
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.subsidyNew,
        component: VptasApplicationSubsidyComponent
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.subsidyEdit,
        component: VptasApplicationSubsidyComponent
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.tripList,
        component: VptasApplicationTripListComponent
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.invoiceList,
        component: VptasInvoiceListComponent
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.invoiceListByContact,
        component: VptasInvoiceListComponent
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.list.myApplications,
        component: VictorianPatientTransportAssistanceSchemeApplicationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.list.pendingReview,
        component: VictorianPatientTransportAssistanceSchemeApplicationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.vptasApplication.list.readyForApproval,
        component: VictorianPatientTransportAssistanceSchemeApplicationListComponent,
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemePreApplicationQuestionnaire.edit,
        component: ReferenceDataComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemePreApplicationRebateCalculationRate.list.rebateRatesApproved,
        component: VictorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateListComponent
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemePreApplicationRebateCalculationRate.list.rebateRatesPendingApproval,
        component: VictorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateListComponent
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemePreApplicationRebateCalculationRate.prefix,
        component: VictorianPatientTransportAssistanceSchemeRebateCalculationRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemePreApplicationRebateCalculationRate.edit,
        component: VictorianPatientTransportAssistanceSchemeRebateCalculationRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemePreApplicationRebateCalculationRate.viewPending,
        component: VictorianPatientTransportAssistanceSchemeRebateCalculationRuleComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      // VPTAS Nominated Patient Details Routes
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeNominatedPatientDetails.edit,
        component: VictorianPatientTransportAssistanceSchemeNominatedPatientDetailsComponent,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeApplication.prefix,
        component: VictorianPatientTransportAssistanceSchemeApplication,
        canDeactivate: [ComponentDeactivationService]
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeApplication.newForPerson,
        component: VictorianPatientTransportAssistanceSchemeApplication,
        canDeactivate: [ComponentDeactivationService],
      },
      {
        path: ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeApplication.edit,
        component: VictorianPatientTransportAssistanceSchemeApplication,
        canDeactivate: [ComponentDeactivationService],
      },
      // VPTAS Application Details View (Template 79) - Staff Portal
      // Note: No canDeactivate guard - this is a read-only detail view, not a form submission page
      // Documents are auto-saved on upload, action buttons save immediately
      {
        path: ROUTE_CONSTANTS.vptasApplication.details.view,
        component: ApplicationDetailVptasComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasSpecialist.list,
        component: VptasSpecialistListComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasSpecialist.new,
        component: VptasSpecialistComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasSpecialist.edit,
        component: VptasSpecialistComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasSpecialistProviderInformation.new,
        component: VptasSpecialistProviderInformationComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasSpecialistProviderInformation.edit,
        component: VptasSpecialistProviderInformationComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasLga.list,
        component: VptasLGAListComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasLga.new,
        component: VptasLgaComponent,
      },
      {
        path: ROUTE_CONSTANTS.VptasLga.edit,
        component: VptasLgaComponent,
      },
      {
        path: ROUTE_CONSTANTS.vptasAdjustmentApplication.new,
        component: VptasAdjustmentApplication,
        canDeactivate: [ComponentDeactivationService]
      },
      {
        path: ROUTE_CONSTANTS.vptasAdjustmentApplication.viewAndedit,
        component: VptasAdjustmentApplication,
        canDeactivate: [ComponentDeactivationService]
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
